import type { PossibleTypesMap } from '@apollo/client';
import { ARTICLE_CATEGORY_TYPE_POLICY } from './services/article-category.config';
import { ARTICLE_VERSION_TYPE_POLICY } from './services/article-version.config';
import { ARTICLE_TYPE_POLICY } from './services/article.config';
import { ORGANISATION_TYPE_POLICY } from './services/organisation.config';
import { ORBIT_EXPLORER_TYPE_POLICY } from './services/orbit-explorer.config';
import { STORE_FRONT_TYPE_POLICY } from './services/store-front.config';

/**
 * Enables correct cache normalization / fragment matching for schema interfaces.
 * Without this, polymorphic `StoreFrontItem` rows can be written as `{}` and trigger
 * dev warnings ("Missing field … while writing result {}").
 */
export const POSSIBLE_TYPES: PossibleTypesMap = {
  StoreFrontItem: [
    'StoreFrontItemAssignment',
    'Product',
    'Service',
  ],
};

export const TYPE_POLICIES = {
  ...ARTICLE_TYPE_POLICY,
  ...ARTICLE_VERSION_TYPE_POLICY,
  ...ARTICLE_CATEGORY_TYPE_POLICY,
  ...ORGANISATION_TYPE_POLICY,
  ...ORBIT_EXPLORER_TYPE_POLICY,
  ...STORE_FRONT_TYPE_POLICY,
};
